import {Injectable} from '@angular/core';


@Injectable()
export class FactoryIdToCountryMapper {

    mappings = new Map<string, string>();

    constructor() {
        this.mappings.set("5098","AT");
        this.mappings.set("6061","BE");
        this.mappings.set("6262","CH");
        this.mappings.set("9797","CZ");
        this.mappings.set("0598","DE");
        this.mappings.set("55","DE"); // DE KWK
        this.mappings.set("6666","DK");
        this.mappings.set("7171","ES");
        this.mappings.set("0650","FR");
        this.mappings.set("6803","GB");
        this.mappings.set("3334","IT");
        this.mappings.set("7373","IT");
        this.mappings.set("6142","LU");
        this.mappings.set("5959","NL");
        this.mappings.set("9595","PL");
        this.mappings.set("7777","RO");
        this.mappings.set("9696","SE");
        this.mappings.set("7919","SK");
        this.mappings.set("8098","TR");
    }

    getCountry(id: string): string {
        return this.mappings.get(id) || "";
    }
}
